import React from 'react';
import { Box, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { PasswordRequirements, PasswordStrengthErrors } from '€lib/strings/types';
import PasswordStrengthLine from '€components/PasswordStrengthLine';

type Props = {
    errors: PasswordStrengthErrors;
};

const PasswordStrength: React.FunctionComponent<Props> = ({ errors }) => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    const lenOk = !errors[PasswordRequirements.Length];
    const matchOk = !errors[PasswordRequirements.Match] && lenOk;
    const numberOk = !errors[PasswordRequirements.Number];
    const lowerOk = !errors[PasswordRequirements.LowerCase];
    const upperOk = !errors[PasswordRequirements.UpperCase];
    const specialOk = !errors[PasswordRequirements.SpecialCharacter];

    return (
        <Box
            display="flex"
            flexDirection="column"
            mt={4}
            minWidth="32.4"
            mx={matches ? 'auto' : '0px'}
        >
            <PasswordStrengthLine passed={matchOk} text="Passwords must match" />
            <PasswordStrengthLine passed={lenOk} text="8 or more characters" />
            <PasswordStrengthLine passed={numberOk} text="At least 1 number" />
            <PasswordStrengthLine
                passed={lowerOk && upperOk}
                text="At least 1 upper case & 1 lower case"
            />
            <PasswordStrengthLine passed={specialOk} text="At least 1 special character" />
        </Box>
    );
};

export default PasswordStrength;
